import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status && status >= 400 && status < 600) {
      if (!error.response.data) error.response.data = {};
      error.response.data.status = -1;
    }
    if (error.response && error.response.status === 401) {
      // Handle unauthorized errors here if needed
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
